<template>
  <div class="tradingContent">
    <div>
       <el-input
            v-model="search.cpmc"
            size="small"
            placeholder="请输入内容"
            style="width: 160px"
          ></el-input>
            <select-from-dictionary
          :code="'guaranty'"
          :placeholder="'担保方式'"
          :default-val="search.dbfsc"
          :cus-style="'width: 155px; margin-left: 10px; display:inline-block'"
          size="small"
          @change="changeGuaranty"
        />
   <el-button icon="el-icon-search" size="small"  style="margin-left: 10px;" @click="handleQuery">查询</el-button>
        <el-button type="success"  icon="el-icon-plus"  size="small"  style="margin-left: 10px;" @click="handleAdd">发布需求</el-button>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      :highlight-current-row="true"
      stripe
      style="width: 100%; margin-top: 20px; text-algin: center;border-radius: 16px;"
    >
      <el-table-column label="序号" type="index" width="50" align="center" />
      <el-table-column prop="qymc"  label="企业名称"    align="center"/>
      <el-table-column prop="cpmc"  label="产品名称"  width="150"  align="center"/>
      <el-table-column prop="dked" label="贷款额度">
        <template slot-scope="scope">
            <span>{{ scope.row.dked + '万元'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dkqx" label="贷款期限">
          <template slot-scope="scope">
            <span>{{ scope.row.dkqx + '月'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="zxdklv" label="年利率范围"  width="100" >
          <template slot-scope="scope">
            <span>{{ scope.row.zxdklv+'%' +' ~ '+ scope.row.zddklv + '%'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dbfs" label="担保方式" width="80" />
        <el-table-column prop="xdlx" label="信贷类型"  />
        <el-table-column prop="lxrxm" label="企业联系人及电话" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.lxrxm +'  '+ scope.row.lxrdh }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="rzyt" width="160" label="融资用途">
          <template slot-scope="scope">
            <el-popover placement="top-start" width="200" trigger="hover">
              <div class="table-popover custom-scrollbar" v-html="scope.row.rzyt"></div>
              <div slot="reference" class="table-text">{{ scope.row.rzyt }}</div>
            </el-popover>
          </template>
        </el-table-column>
      <el-table-column
        prop="a11"
        label="操作"
        width="150"
        fixed="right"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="text"  size="small"  @click="handleEdit(scope.row)">修改</el-button>
          <el-button type="text"  size="small"  @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, sizes,prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100]"
        :current-page.sync="page.current"
        :page-size.sync="page.size"
        :total="page.total"
        @current-change="queryData"
        @size-change="handleQuery"
      />
    </div>

    <edit-dialog
      v-if="editDialogData.visible"
      :viewData="editDialogData.viewData"
      :show-dialog="editDialogData.visible"
      :dialog-title="editDialogData.title"
      @closeDialog="closeEditDialog"
    />
  </div>
</template>
<script>
import orderDetails from "./orderDetails.vue";
import editDialog from "./components/editDialog.vue";
import { getFinancingNeedPage,deleteFinancingNeed } from "./viewApi";
export default {
  components: {
    orderDetails,
    editDialog
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_API,
      page: {
        size: 10,
        total: 0,
        current: 1,
      },
      tableData: [],
      search: {
        cpmc: null,
        xdlxbm: null,
      },
      editDialogData: {
        visible: false,
        title: "新增",
        viewData: {},
      },
    };
  },
  created() {
    this.queryData();
  },
  methods: {
    
    handleQuery() {
      this.page.current = 1;
      this.queryData();
    },

    // 新增
    handleAdd() {
      this.editDialogData.title = "新增";
      this.editDialogData.visible = true;
    },

    //修改
    handleEdit(row){
      this.editDialogData.title = '修改';
      this.editDialogData.viewData = { ...row };
      this.editDialogData.visible = true;
    },

    //详情
    handleDetails(row,) {
      this.editDialogData.title = '详情';
      this.editDialogData.viewData = { ...row };
      this.editDialogData.visible = true;
    },


    handleDelete(row) {
      this.$confirm(`确认删除吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((_) => {
        deleteFinancingNeed({id:row.id}).then((res) => {
          this.$baseMessage("删除成功。", "success");
          this.queryData();
        });
      });
    },
 
    // 关闭弹窗
    closeEditDialog(needRefresh) {
      this.editDialogData.viewData = null;
      this.editDialogData.visible = false;
      if (needRefresh) {
        this.queryData();
      }
    },

    changeGuaranty(data){
      this.search.dbfsc = data.code;
      this.search.dbfsm = data.dictionaryKey;
      queryData()
    },

    async queryData() {
      let params = {
        ...this.search,
        ...this.page,
      };
      let res = await getFinancingNeedPage(params);
      if (res.data) {
        this.tableData = res.data.records;
        this.page.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.workContent {
}
</style>